import { SvgIconProps } from 'ui/icons/SvgIcon';
import {
  EmailBounce,
  EmailClick,
  EmailOpen,
  EmailSend,
  EmailSendSkip,
  HostedUnsubscribe,
  InAppClick,
  InAppClose,
  InAppDelivery,
  InAppDelete,
  InAppSend,
  InAppOpen,
  InAppSendSkip,
  InboxMessageImpression,
  InboxSession,
  JourneyExit,
  PushBounce,
  PushOpen,
  PushSend,
  PushSendSkip,
  SMSBounce,
  SMSClick,
  SMSSend,
  SMSSendSkip,
  WebPushSend,
  WebPushSendSkip,
  AppUninstall,
  ListSubscribe,
  ListUnsubscribe,
  MarkedAsSpam,
  Purchase,
  SMSDelivered,
} from 'ui/icons/events';

import { SystemEventName, EventName } from '../domain';

export const EVENT_HELP_DOC_LINK = 'https://support.iterable.com/hc/articles/206430615';

export const AGGREGATE_EVENT_LABELS: Record<SystemEventName, string> = {
  emailBounce: 'Total Email Bounces',
  emailClick: 'Total Email Clicks',
  emailComplaint: 'Total Email Complaints',
  emailOpen: 'Total Email Opens',
  emailSend: 'Total Email Sends',
  emailSendSkip: 'Total Email Send Skips',
  emailSubscribe: 'Subscribes',
  emailUnSubscribe: 'Unsubscribes',
  embeddedSend: 'Total Embedded Sent',
  embeddedClick: 'Total Embedded Clicks',
  embeddedDismiss: 'Total Embedded Dismissed',
  embeddedReceived: 'Total Embedded Received',
  embeddedImpression: 'Total Embedded Impressions',
  hostedUnsubscribeClick: 'Total Hosted Unsubscribe Clicks',
  inAppClick: 'Total In-App Clicks',
  inAppClose: 'Total In-App Closes',
  inAppDelete: 'Total In-App Deletes',
  inAppDelivery: 'Total In-App Deliveries',
  inAppOpen: 'Total In-App Opens',
  inAppRecall: 'Total In-App Recalls',
  inAppSend: 'Total In-App Sends',
  inAppSendSkip: 'Total In-App Send Skips',
  inboxMessageImpression: 'Total Inbox Message Impressions',
  inboxSession: 'Total Inbox Sessions',
  journeyExit: 'Total Journey Exits',
  purchase: 'Total Purchases',
  pushBounce: 'Total Push Bounces',
  pushOpen: 'Total Push Opens',
  pushSend: 'Total Push Sends',
  pushSendSkip: 'Total Push Send Skips',
  pushUninstall: 'Total Push Uninstalls',
  smsBounce: 'Total SMS Bounces',
  smsClick: 'Total SMS Clicks',
  smsReceived: 'Total SMS Received',
  smsSend: 'Total SMS Sends',
  smsSendSkip: 'Total SMS Send Skips',
  webPushSend: 'Total Web Push Sends',
  webPushSendSkip: 'Total Web Push Send Skips',
  whatsAppSeen: 'Total WhatsApp Seen',
  whatsAppSendSkip: 'Total WhatsApp Send Skips',
  whatsAppBounce: 'Total WhatsApp Bounced',
  whatsAppReceived: 'Total WhatsApp Received', // whatsAppReply
  whatsAppClick: 'Total WhatsApp Clicks',
  whatsAppSend: 'Total WhatsApp Sends',
};

export const EVENT_ICONS: Record<
  EventName,
  React.ComponentType<React.PropsWithChildren<SvgIconProps>>
> = {
  [SystemEventName.emailSend]: EmailSend,
  [SystemEventName.emailOpen]: EmailOpen,
  [SystemEventName.emailClick]: EmailClick,
  [SystemEventName.emailUnSubscribe]: ListUnsubscribe,
  [SystemEventName.hostedUnsubscribeClick]: HostedUnsubscribe,
  [SystemEventName.emailSubscribe]: ListSubscribe,
  [SystemEventName.emailBounce]: EmailBounce,
  [SystemEventName.emailComplaint]: MarkedAsSpam,
  [SystemEventName.embeddedSend]: InAppSend,
  [SystemEventName.embeddedClick]: InAppSend,
  [SystemEventName.embeddedDismiss]: InAppSend,
  [SystemEventName.embeddedReceived]: InAppSend,
  [SystemEventName.embeddedImpression]: InAppSend,
  [SystemEventName.pushSend]: PushSend,
  [SystemEventName.pushBounce]: PushBounce,
  [SystemEventName.pushOpen]: PushOpen,
  [SystemEventName.emailSendSkip]: EmailSendSkip,
  [SystemEventName.inAppClick]: InAppClick,
  [SystemEventName.inAppClose]: InAppClose,
  [SystemEventName.inAppDelete]: InAppDelete,
  [SystemEventName.inAppDelivery]: InAppDelivery,
  [SystemEventName.inAppOpen]: InAppOpen,
  [SystemEventName.inAppSend]: InAppSend,
  [SystemEventName.inAppSendSkip]: InAppSendSkip,
  [SystemEventName.inAppRecall]: InAppDelete,
  [SystemEventName.inboxMessageImpression]: InboxMessageImpression,
  [SystemEventName.inboxSession]: InboxSession,
  [SystemEventName.journeyExit]: JourneyExit,
  [SystemEventName.pushSendSkip]: PushSendSkip,
  [SystemEventName.pushUninstall]: AppUninstall,
  [SystemEventName.purchase]: Purchase,
  [SystemEventName.smsBounce]: SMSBounce,
  [SystemEventName.smsClick]: SMSClick,
  [SystemEventName.smsReceived]: SMSDelivered,
  [SystemEventName.smsSend]: SMSSend,
  [SystemEventName.smsSendSkip]: SMSSendSkip,
  [SystemEventName.webPushSend]: WebPushSend,
  [SystemEventName.webPushSendSkip]: WebPushSendSkip,
  [SystemEventName.whatsAppSeen]: SMSDelivered,
  [SystemEventName.whatsAppSendSkip]: SMSSendSkip,
  [SystemEventName.whatsAppBounce]: SMSBounce,
  [SystemEventName.whatsAppReceived]: SMSDelivered, // whatsAppReply
  [SystemEventName.whatsAppClick]: SMSClick,
  [SystemEventName.whatsAppSend]: SMSSend,
};
